import { css } from '@emotion/react';
import type { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import { ContentContainer } from '../../../components/layout/contentContainer';
import { HeaderContainer } from '../../../components/layout/headerContainer';
import { QuestionnaireHeader } from '../../../components/questionnaire/header';
import { commonMessages } from '../../../i18n/commonMessages';
import { styled } from '../../../styled';
import { Theme } from '../../../theme/interface/detailed';
import { useSDK } from '../../App';
import { AfterQuestionnaireButton } from './afterQuestionnaireButton';
import { AfterQuestionnaireHeader } from './AfterQuestionnaireHeader';
import { AfterQuestionnaireText } from './AfterQuestionnaireText';

type Interface = {
	className: string;
};

const styles = css`
	align-items: center;
	display: flex;
	flex-flow: column;
	justify-content: center;
`;

const Component = (props: Interface): ReactElement => {
	const rootStore = useSDK();
	const { formatMessage } = useIntl();
	return (
		<>
			<HeaderContainer>
				<QuestionnaireHeader>
					{rootStore.formsStore.chatQuestionnaireSheet?.header || 'Опрос'}
				</QuestionnaireHeader>
			</HeaderContainer>
			<ContentContainer {...props}>
				{rootStore.formsStore.chatQuestionnaireSheet?.afterSubmitText1 && (
					<AfterQuestionnaireHeader>
						{rootStore.formsStore.chatQuestionnaireSheet.afterSubmitText1}
					</AfterQuestionnaireHeader>
				)}
				{rootStore.formsStore.chatQuestionnaireSheet?.afterSubmitText2 && (
					<AfterQuestionnaireText>
						{rootStore.formsStore.chatQuestionnaireSheet.afterSubmitText2}
					</AfterQuestionnaireText>
				)}
				<AfterQuestionnaireButton onClick={rootStore.uiStateStore.closeAfterQuestionnaireMessage}>
					{formatMessage(commonMessages.close)}
				</AfterQuestionnaireButton>
			</ContentContainer>
		</>
	);
};

export const AfterQuestionnaireMessage = styled(Component)(
	({ theme }: { theme: Theme }) => theme.questionnaireField.text.afterQuestionnaireContainer,
	styles
);
